export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'Winkel-ID: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Gebruikersnaam: ',
      placeholder: 'Gebruikersnaam voor verificatie tussen uw winkel en WinOrder',
      validation: {
        required: 'Gebruikersnaam mag niet leeg zijn',
        min: 'Minimale lengte gebruikersnaam is 3 tekens',
      },
    },
    password: {
      label: 'Wachtwoord: ',
      placeholder: 'Wachtwoord voor verificatie tussen uw winkel en WinOrder',
      validation: {
        required: 'Wachtwoord mag niet leeg zijn',
        complexity: 'Het wachtwoord moet minimaal 8 tekens lang zijn en minimaal één letter bevatten',
      },
    },
  },
  labels: {
    credentials: 'Inloggegevens:',
  },
  instructions: {
    title: 'Installatie-instructies:',
    step_1: 'Open "Instellingen" → "Programma-instellingen" in WinOrder.',
    step_2: 'Helemaal bovenaan vindt u de knop "Online winkel instellen".',
    step_3:
      'In het volgende venster ziet u alle winkels die vooraf zijn geconfigureerd in WinOrder. Selecteer "FoodAmigos" en klik vervolgens op "Volgende".',
    step_4:
      'Vervang in het volgende venster <0>{{storeid_placeholder}}</0> door <1>{{company_id}}</1> in het veld "URL van de webservice". <br />Het eindresultaat ziet er als volgt uit: <2>{{url}}</2>',
    step_5: 'Voer in hetzelfde venster <ClickToCopy>{{username}}</ClickToCopy> in het veld "Gebruikersnaam" in.',
    step_6:
      'Voer in hetzelfde venster <ClickToCopy>{{password}}</ClickToCopy> in het veld "Wachtwoord" in. Klik vervolgens op de knop "Volgende".',
    step_7:
      'WinOrder test nu de verbinding met de FoodAmigos-interface. Klik op "Volgende" en in het volgende venster op "Voltooien".',
    step_8: 'Sla de instellingen op.',
  },
  buttons: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    edit: 'Bewerken',
  },
  toasts: {
    error: 'Wijzigingen opslaan mislukt',
    success: 'Wijzigingen opgeslagen',
  },
};
